// keep this updated with the billable currency in api_rails/app/models/project.rb
const BILLABLE_CURRENCIES = [
  'jpy',
  'usd',
  'aud',
  'eur',
  'gbp',
  'hkd',
  'idr',
  'krw',
  'myr',
  'sgd',
  'thb',
  'twd',
];

angular.module('zc.core')
  .filter('billable_currencies', billableCurrencies);

billableCurrencies.$inject = [];
function billableCurrencies() {
  return function(arr) {
    const project = arr[0];

    if(project.fixed_invoice_amount || project.product_line === 'zenclerk_lp') {
      return BILLABLE_CURRENCIES;
    }
    // twd has no exchange rate so it cant be billed in usd
    if(project.currency === 'twd') {
      return ['twd'];
    }
    // always gonna be like ['jpy', 'usd']
    if(!BILLABLE_CURRENCIES.includes(project.currency)) {
      return ['usd'];
    }

    // filter out duplicate if dashboard currency is usd
    const currencies = [project.currency, 'usd'].filter((v, i, a) => a.indexOf(v) === i);
    return currencies;
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/billable_currencies.js